import useAdminOverrides from './hooks/useAdminOverrides';

const AdminHooks: React.FC = () => {
  useAdminOverrides();

  return null;
};

export default AdminHooks;
